import React from 'react';
import {useEffect, useReducer, useState} from 'react';
import {Link} from 'react-router-dom';
import './styling/search.css';
import './styling/new.css';
import './styling/err.css';
import './styling/filter.css';

var start = 0;
export var myData = [];

export const Search = () => {
    useEffect(() => {
        let myInput = document.getElementById('my-input');
        myInput.addEventListener('input', function(event) {
            if(event.keyCode === 13){
                let myBtn = document.getElementById('btn');
                myBtn.click();
            }
        });
    }, []);

    const [state, dispatch] = useReducer(reducer, {book: "", result: [], err: false});
    const [total, setTotal] = useState(0);
    const [num, setNum] = useState(1);
    const [search, setSearch] = useState("");
    const [load, setLoad] = useState(false);

    if(load) {
        document.body.style.overflowY = 'hidden';
    }else {
        document.body.style.overflowY = 'auto';
    }

    function reducer(state, action){
        switch (action.type){
            case "SET_BOOK":
                return {book: action.myBook, result: [], err: false};
            case "RESULT":
                myData = action.data;
                return {book: action.myBook, result: action.data, err: false};
            case "ERR":
                return {book: "", result: [], err: true};
            default :
                return {book: "", result: [], err: false};
        }
    }

    function handleChange (event) {
        const book = event.target.value;
        dispatch({type: "SET_BOOK", myBook: book});
        setSearch(book);
    }

    const myFetch = (url) => {
        setLoad(true);
        fetch(url)        
        .then(response => response.json())
        .then(data => {
            let final = [];
            let all = data.totalItems;
            final.push(...data.items);
            dispatch({type: "RESULT", data: final});
            setTotal(all);
            setLoad(false);
        }).catch(() => {setTotal(0); setLoad(false); return dispatch({type: "ERR"})});
    }

    function handleSubmit (event) {
        event.preventDefault();
        const url = `https://www.googleapis.com/books/v1/volumes?q=${state.book}&key=AIzaSyCSvxVOXpQ8DKk8rHHO2MGvv3BGYCnkphk&maxResults=30&printType=books`;
        myFetch(url);
        window.scrollTo(0, 500);
        setNum(1);
    }

    const next = () => {
        if(num < Math.ceil(total/30)){
            setNum(num + 1);
            start += 30;
            const url = `https://www.googleapis.com/books/v1/volumes?q=${search}&key=AIzaSyCSvxVOXpQ8DKk8rHHO2MGvv3BGYCnkphk&maxResults=30&startIndex=${start}&printType=books`;
            myFetch(url);
            window.scrollTo(0, 500);
        }
    }

    const pre = () => {
        if(num > 1){
            setNum(num - 1);
            start -= 30;
            const url = `https://www.googleapis.com/books/v1/volumes?q=${search}&key=AIzaSyCSvxVOXpQ8DKk8rHHO2MGvv3BGYCnkphk&maxResults=30&startIndex=${start}&printType=books`;
            myFetch(url);
            window.scrollTo(0, 500);
        }
    }

    return (<>
        <div className="search">
            <h1><span>المكتبة الإسلامية </span> أهلا بك في</h1>
            <div>
                <form onSubmit={handleSubmit} id="my-form">
                    <input onChange={handleChange} type="text" placeholder="إبحث عن كتاب أو قسم الكتاب أو إسم المؤلف" id="my-input" autoComplete="off"/>
                    <button id="btn" type="submit"></button>
                </form>
           </div>
        </div>
        <div className="new-list">
            <h2>نتائج البحث</h2>
            <div className="number-of-total">{total} : عدد نتائج البحث</div>
            <section id="books">
            {state.result.length !== 0 && 
            state.result.map((obj) => {
                return <Books key={obj.id}
                name={obj.volumeInfo.title || "لا يوجد إسم للكتاب"}
                author={obj.volumeInfo.authors && obj.volumeInfo.authors[0]}
                img={obj.volumeInfo.imageLinks && obj.volumeInfo.imageLinks.thumbnail}
                id={obj.id}/>
            })}
            {state.err && <Err/>}
            {load && <Loading/>}
            </section>
        </div>
        <div className="next-pre">
            <button id="pre" onClick={() => pre()}>&lt;</button>
            <span>{num}</span>
            <button id="next" onClick={() => next()}>&gt;</button>
        </div>
        </>
    )
}
const Err = () => {
    return <div className="err">
        <img src="data:image/svg+xml;base64,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" alt="404"/>
        <h2>لم يتم العثور علي الكتاب</h2>
    </div>
}

const Books = ({name, img, author, id}) => {
    return (
          <div>
            <img src={img} alt={name || "صورة الكتاب"}/>
            <h3>{name || "إسم الكتاب"}</h3>
            <h4>{author || "إسم المؤلف"}</h4>
            <Link to={`/${id}`}>
                <button onClick={() => {window.scroll(0, 0);}}>قراءة</button>
            </Link>
          </div>
    )
}

const Loading = () => {
    return <>
        <div className="loading">
            <span></span>
        </div>
    </>
}
